import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'JOB理論1dayワークショップ',
  title1: 'JOB理論1dayワークショップ',
  introduction_text:
    '顧客理解を深めるワークショップを実施しました。このワークショップはJOB理論に基づき、顧客が成し遂げたいことを明確にしました。これをもとに、ソリューションアイデアの創出まで実施しました。',
  company: '株式会社安藤・間',
  tag1text: '組織開発・人材育成',
  tag1src: '/cases/hip/',
  industryTagText: 'メーカー/製造/建設',
  industryTagSrc: '/cases/manufacturing/',
  color: '',
  background: '#F8F8F8',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/ando.webp',
  alt: 'JOB理論1dayワークショップ',
  imgClass: 'fv_img_adjust1',
  noProtrude: true,
}

// プロジェクト概要
export const overviewTitle = '部門横断のDX推進ワークショップのご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: 'JOB理論により"顧客"の成し遂げたい事を明確にすることに主眼をおき、ワークショップを実施いたしました。',
  },
  {
    text: 'DXを推進する部門、技術研究開発を行う部門、営業部門、設計部門よりワークショップにご参加いただき、部門横断で自部門の"顧客"を想定し、他部門からのフィードバックを得ることにより"顧客"のJOBをより具体的にし、それらを元にソリューションアイデアに落とし込みました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'DX化を旗振り出来る人材が見つからない',
        text: '',
      },
      {
        title: '現場と本社の方針に乖離がある',
        text: '',
      },
      {
        title: 'アイデアを出しても方向性がまとまらない',
        text: '',
      },
    ],
    solutions: [
      {
        title: 'ワークショップでボトムアップ型の実践教育',
        text: '',
      },
      {
        title: 'ソリューションアイデアを具体的にし、現場と本社の方針を一致',
        text: '',
      },
      {
        title: 'アイデア単体でなく、顧客視点で方向性の明確化',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
